<template>
    <div class="pb-4 text-a-brown-502314 border-b border-a-brown-d7c7b8">
        <div class="text-14 lg:text-16 pb-4 font-bold">{{lbl.shoppingcart.payment_method}}</div>
        <div>
            <div class="lg:flex" 
                v-for="(item,index) in paymentfilter" 
                :key="index" >
                <div class="flex pb-4 lg:pr-3" v-if="checkDeliveryMethod(item)" >
                    <img class="ml-0 mr-2 my-auto" v-show="PlaceOrderStore.state.placeOrder.channel == item.id" src="@/assets/icon/ic-radio-active-red.svg" />
                    <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selecChannel(item.id)"  v-show="PlaceOrderStore.state.placeOrder.channel != item.id" src="@/assets/icon/ic-radio-inactive-red.svg" />
                    <div class="text-14 lg:text-16 ml-0 mr-auto my-auto">
                        <img v-if="item.imageUrl" class="inline-block mr-1" :src="item.imageUrl" />
                        {{getNamePaymentChannel(item)}}
                    </div>
                </div>
            </div>
            <!-- <div class="lg:flex">
                <div class="flex pb-4 lg:pr-3" v-if="delivery.deliveryMethod != 'InStore'">
                    <img class="ml-0 mr-2 my-auto" v-show="PlaceOrderStore.state.placeOrder.channel == 'pod'" src="@/assets/icon/ic-radio-active-red.svg" />
                    <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selecChannel('pod')"  v-show="PlaceOrderStore.state.placeOrder.channel != 'pod'" src="@/assets/icon/ic-radio-inactive-red.svg" />
                    <div class="text-14 lg:text-16 ml-0 mr-auto my-auto">{{lbl.shoppingcart.cash}}</div>
                </div>
                <div class="flex pb-3 lg:pr-3">
                    <img class="ml-0 mr-2 my-auto" v-show="PlaceOrderStore.state.placeOrder.channel == 'omise'" src="@/assets/icon/ic-radio-active-red.svg" />
                    <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selecChannel('omise')" v-show="PlaceOrderStore.state.placeOrder.channel != 'omise'" src="@/assets/icon/ic-radio-inactive-red.svg" />
                    <div class="text-14 lg:text-16 ml-0 mr-auto my-auto">{{lbl.shoppingcart.credit}}</div>
                </div>
                <div class="flex pb-3">
                    <img class="ml-0 mr-2 my-auto" v-show="PlaceOrderStore.state.placeOrder.channel == 'linepay'" src="@/assets/icon/ic-radio-active-red.svg" />
                    <img class="ml-0 mr-2 my-auto cursor-pointer" @click="selecChannel('linepay')" v-show="PlaceOrderStore.state.placeOrder.channel != 'linepay'" src="@/assets/icon/ic-radio-inactive-red.svg" />
                    <div class="text-14 lg:text-16 ml-0 mr-auto my-auto text-a-red-d62300"><img class="inline-block mr-1" src="@/assets/shopping_cart/line-pay.png" />Rabbit LINE Pay</div>
                </div>
            </div> -->

            <div class="bg-a-egg-e9dac5 rounded-10 p-4" v-if="PlaceOrderStore.state.placeOrder.channel == 'omise'">
                <CreditCardList
                    ref="credit-card-list"
                ></CreditCardList>
                <div class="px-8 lg:px-24">
                    <WhiteButton @click="clickAddNewCard()"
                        customClass="flex p-2 w-full">
                        <img class="ml-auto mr-2 my-auto" src="@/assets/icon/ic-add-red-2.svg" />
                        <div class="ml-0 mr-auto text-a-red-d62300 text-14 lg:text-16 font-bold">{{lbl.shoppingcart.add_credit}}</div>
                    </WhiteButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// components
import WhiteButton from "@/components/Button/WhiteButton.vue";
import CreditCardList from "@/module/CreditCard/component/CreditCardList.vue";
// mixin
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
import ModalMixin from "@/mixin/ModalMixin";
//service
import BKCart from '../service/BKCart';

export default {
    name: "PaymentMethod",
    mixins: [DeliveryMixin,LocaleMixin,ErrorApiMixin,ModalMixin],
    inject: ['PlaceOrderStore'],
    components: {
        WhiteButton,
        CreditCardList
    },
    props: {
        hideChannel: { type: Array, default: () => []},
        disablePayment: { type: Boolean, default: false}
    },
    data: function() {
        return {
            disableCash: false,
            paymentChannelList: [],
            paymentfilter: []
        };
    },
    created: function() {
        if (this.PlaceOrderStore.state.placeOrder.total > 850 || this.delivery.deliveryMethod == "InStore") {
            this.disableCash = true;
            this.PlaceOrderStore.state.placeOrder.channel = 'omise';
        }

        if (this.disablePayment) {
            this.PlaceOrderStore.state.placeOrder.channel = 'pod';
        }
    },
    mounted: function(){
        this.modal.loadingModal.show()
        this.getPaymentChannel()
        this.modal.loadingModal.hide()
    },
    methods: {
        selecChannel: function(channel) {
            if (this.disablePayment) return;
            if (channel == 'pod' && this.disableCash) return;
            this.PlaceOrderStore.state.placeOrder.channel = channel;
        },
        clickAddNewCard: function() {
            this.$router.push("/addcreditcard");
        },
        getSelectCreditCard: function() {
            let selectCreditCard = this.$refs['credit-card-list'].getSelectCreditCard();
            return selectCreditCard;
        },
        getPaymentChannel: function() {
            return new Promise((resolve) => {
                BKCart.apiGetPaymentChannel().subscribe({
                    next: (data) => {
                        // filter data by hideChannel
                        this.paymentChannelList = data;


                        if (this.hideChannel.length > 0) {
                            this.paymentfilter = data.filter(item => !this.hideChannel.includes(item.id));
                        } else {
                            this.paymentfilter = data;
                        }
                        // check place order contain channel in paymentfilter
                        if (!this.paymentfilter.find(item => item.id == this.PlaceOrderStore.state.placeOrder.channel)) {
                            this.PlaceOrderStore.state.placeOrder.channel = this.paymentfilter[0].id;
                        }
                        
  
                        if (this.PlaceOrderStore.state.placeOrder.total == 0) {
                            if(this.paymentfilter.find(item => item.id == 'omise_promptpay')){
                                this.PlaceOrderStore.state.placeOrder.channel = 'omise_promptpay';
                            } else {
                                this.PlaceOrderStore.state.placeOrder.channel = 'omise';
                            }
                        }
                        
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        filterPaymentChannel: function(){
            this.paymentfilter = this.paymentChannelList.filter(item => !this.hideChannel.includes(item.id));
            if (!this.paymentfilter.find(item => item.id == this.PlaceOrderStore.state.placeOrder.channel)) {
                this.PlaceOrderStore.state.placeOrder.channel = this.paymentfilter[0].id;
            }
        },
        getNamePaymentChannel: function(item){
            if(this.localeCode == 1033){ //from locale mixin
                return item.nameEN
            }
            return item.name
        },
        checkDeliveryMethod: function(item){
            if(item.id == 'pod'){
                if(this.delivery.deliveryMethod != 'InStore'){
                    return true
                } else {
                    return false
                }
            }
            return true;
        }
    }
}
</script>

<style>

</style>
